// extracted by mini-css-extract-plugin
export default {"container":"ObservedUsersPage_container__HiNQ8","content":"ObservedUsersPage_content__1OHJi","header_container":"ObservedUsersPage_header_container__T9XVR"};